import React, { useEffect, useLayoutEffect, useRef } from 'react'

const GRIEVANCE_HTML_URL = `${process.env.PUBLIC_URL}/grievance-redressal-and-disclosures.html`
const GRIEVANCE_POLICY_PDF_URL = `${process.env.PUBLIC_URL}/pdf/ProsParity_Grievance_Redressal_Policy.pdf`

function prepareEmbeddedPage(iframe: HTMLIFrameElement) {
  const doc = iframe.contentDocument
  if (!doc) return

  doc.querySelector('.nav')?.remove()
  doc.querySelector('.foot')?.remove()

  const subnav = doc.querySelector('.subnav') as HTMLElement | null
  if (subnav) {
    subnav.style.top = '0'
  }

  const downloadLink = doc.querySelector('.hero__download') as HTMLAnchorElement | null
  if (downloadLink) {
    downloadLink.href = GRIEVANCE_POLICY_PDF_URL
    downloadLink.setAttribute(
      'download',
      'ProsParity_Grievance_Redressal_Policy.pdf',
    )
  }

  doc.documentElement.style.scrollPaddingTop = '128px'
}

export default function GrievanceRedressalAndDisclosures() {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe) return

    const handleLoad = () => prepareEmbeddedPage(iframe)

    iframe.addEventListener('load', handleLoad)

    return () => {
      iframe.removeEventListener('load', handleLoad)
    }
  }, [])

  return (
    <>
      <section className="pt-10 lg:pt-12 blade-bottom-padding-lg min-h-[300px] bg-blueGreen">
        <div className="text-center px-4 mt-6 md:mt-8 lg:mt-0">
          <div className="blade-top-padding blade-top-margin-sm pb-4">
            <h1 className="font-medium text-2xl text-white mxlg:text-3xl 2xl:text-4xl leading-tight">
              Grievance Redressal &amp; Disclosures
            </h1>
          </div>
        </div>
      </section>

      <iframe
        ref={iframeRef}
        src={GRIEVANCE_HTML_URL}
        title="Grievance Redressal & Disclosures"
        className="block w-full border-0 bg-white"
        style={{ height: 'calc(100vh - 80px)', minHeight: '720px' }}
      />
    </>
  )
}
